var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticStyle:{"text-align":"center","user-select":"none","background":"inherit"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" @ "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }